module.exports = __webpack_public_path__ + "static/onafadeji-fa94ebeb0b421e495868afeba029be9b.png";